<div class="wnl-header">

  @if (patient().isObstetric()) {
  <p>
    WNL: Alert, oriented, no distress. Bonding with baby if applicable, breasts soft and non-tender with no lumps or
    engorgement noted. Nipples intact and everted bilaterally.
  </p>
  } @else {
  <p>
    WNL: Alert, oriented, no distress.
  </p>
  }
  <mat-checkbox [checked]="wnlGroup.allWnl" [indeterminate]="wnlGroup.someWnl"
    (change)="wnlGroup.setAllWnl($event.checked)"
    [ngClass]="{'wnl-checked': wnlGroup.allWnl && !wnlGroup.someWnl, 'wnl-indeterminate': wnlGroup.someWnl}">
    All Within Normal Limits
  </mat-checkbox>
</div>

<div [formGroup]="formGroup()" class="form-container" wnlGroup #wnlGroup="wnlGroup">
  <assessment-row title="LOC">
    <emr-input type="select" [control]="formGroup().controls.loc" [options]="locOptions" [wnlControl]="'loc'"
      [wnlDefault]="'WNL'" />
  </assessment-row>

  <assessment-row title="Orientation">
    @if (patient().isPediatric()) {
      <emr-checkbox-group [control]="formGroup().controls.orientation" [options]="pediatricOrientationOptions"
        [wnlControl]="'orientation'" [wnlDefault]="[]" />
    } @else {
      <emr-checkbox-group [control]="formGroup().controls.orientation" [options]="orientationOptions"
        [wnlControl]="'orientation'" [wnlDefault]="[]" />
    }
  </assessment-row>
    

  <assessment-row title="Lethargic?">
    <emr-checkbox [control]="formGroup().controls.lethargic" label="Yes" [wnlControl]="'lethargic'"
      [wnlDefault]="false" />
  </assessment-row>

  <assessment-row title="Inappropriate for Age?">
    <emr-checkbox [control]="formGroup().controls.inappropriateForAge" label="Yes"
      [wnlControl]="'inappropriateForAge'" [wnlDefault]="false" />
  </assessment-row>

  <assessment-row title="In distress?">
    <emr-checkbox [control]="formGroup().controls.distress" label="Yes" [wnlControl]="'distress'"
      [wnlDefault]="false" />
  </assessment-row>

  @if (patient().isObstetric()) {
    <assessment-row title="Not bonding with baby appropriately">
      <emr-checkbox [control]="formGroup().controls.babyBonding" label="Yes" [wnlControl]="'babyBonding'"
        [wnlDefault]="false" />
    </assessment-row>

    <assessment-row title="Breast Abnormalities Present?">
      <emr-checkbox [control]="formGroup().controls.hasBreastAbnormalities" label="Yes"
        [wnlControl]="'hasBreastAbnormalities'" [wnlDefault]="false" />
    </assessment-row>

    @if (areBreastsAbnormal) {
      <assessment-row title="Nipple Abnormalities">
        <emr-input type="text" [control]="formGroup().controls.nippleAbnormalitiesNotes"></emr-input>
      </assessment-row>

      <assessment-row title="Breast Abnormalities">
        <emr-input type="text" [control]="formGroup().controls.breastAbnormalitiesNotes"></emr-input>
      </assessment-row>
    }
  }

  @if (patient().isPediatric()) {
    <assessment-row title="Support Person at Bedside">
      <emr-checkbox id="support-person-at-bedside" [control]="formGroup().controls.supportPersonAtBedside"
        label="Yes" [wnlControl]="'supportPersonAtBedside'" [wnlDefault]="false" />
    </assessment-row>
    @if (supportPersonAtBedside) {
      <assessment-row title="Support Person Relation">
        <emr-input
          id="support-person-relation"
          type="select"
          [control]="formGroup().controls.supportPersonType"
          [options]="supportPersonTypeOptions"
        />
      </assessment-row>
      <assessment-row title="Support Person Name">
        <emr-input id="support-person-name" type="text" [control]="formGroup().controls.supportPersonName" />
      </assessment-row>
    }
  }

  <assessment-row title="Other Findings">
    <emr-input type="text" [control]="formGroup().controls.otherFindings" [wnlControl]="'otherFindings'"
      [wnlDefault]="''" />
  </assessment-row>
</div>